import {
  ExploreColumnType,
  exploreColumnTypeToLabel,
} from "@/v2/entities/explore/columns/ExploreColum.model";
import { mandatoryColumns } from "./ExploreDisplayOptions.consts";
import { ColumnSearchInput } from "./ColumnSearchInput";
import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";

interface DisplayColumnsSectionProps {
  availableColumns: ExploreColumnType[];
  selectedColumns: ExploreColumnType[];
  onColumnToggle: (column: ExploreColumnType) => void;
}

export function DisplayColumnsSection({
  availableColumns,
  selectedColumns,
  onColumnToggle,
}: DisplayColumnsSectionProps) {
  const [searchColumns, setSearchColumns] = useState("");
  const filteredColumns = availableColumns.filter((column) => {
    if (searchColumns.length > 0) {
      const label = exploreColumnTypeToLabel[column] || column;
      return label.toLowerCase().includes(searchColumns.toLowerCase());
    }
    return true;
  });

  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm text-gray-500">Display properties</label>

      <ScrollArea className="max-h-[200px] text-sm overflow-y-auto">
        <div className="flex flex-col gap-1">
          {mandatoryColumns.map((column) => (
            <Button
              key={column}
              variant="ghost"
              size="sm"
              className="flex justify-start gap-2 px-2 py-1 opacity-50"
              disabled
            >
              <Checkbox checked disabled />

              {column === "displayId"
                ? "Display ID"
                : exploreColumnTypeToLabel[column] || column}
            </Button>
          ))}

          {filteredColumns.map((column) => (
            <Button
              key={column}
              variant="ghost"
              size="sm"
              className="flex justify-start gap-2 px-2 py-1"
              onClick={() => onColumnToggle(column)}
            >
              <Checkbox
                checked={selectedColumns.includes(column)}
                onCheckedChange={() => onColumnToggle(column)}
              />
              {exploreColumnTypeToLabel[column] || column}
            </Button>
          ))}
        </div>
      </ScrollArea>

      <div className="py-1">
        <ColumnSearchInput value={searchColumns} onChange={setSearchColumns} />
      </div>
    </div>
  );
}
